import { Helmet } from 'react-helmet-async';
import { Link } from "react-router-dom";
import { useTheme } from "../../context/ThemeContext";
import { getThemeClasses } from "../utils/themeClass";

export default function NoDownload() {
  const { theme } = useTheme();
  const themeClass = getThemeClasses(theme);

  return (
    <div className={`${themeClass.bgColor} ${themeClass.baseText} min-h-screen`}>

    <div className={`min-h-screen px-6 py-12 ${themeClass.bgColor} ${themeClass.baseText}`}>
      <Helmet>
        <title>No-Download Gaming Experience - BrowserArena</title>
        <meta
          name="description"
          content="Skip installations and start playing instantly. Discover the convenience and security of no-download browser games on BrowserArena."
        />
        <link rel="canonical" href="https://browserarena.com/no-download" />
        <meta property="og:title" content="No-Download Gaming Experience - BrowserArena" />
        <meta property="og:description" content="Play browser games instantly without downloading or installing anything. Safe, secure, and fun gaming on BrowserArena." />
        <meta property="og:url" content="https://browserarena.com/no-download" />
        <meta property="og:type" content="website" />
      </Helmet>

      <div className={`max-w-4xl mx-auto rounded-2xl border ${themeClass.borderColor} ${themeClass.overlayBg} shadow-xl shadow-cyan-400/10 backdrop-blur-lg p-8`}>
        <h1 className={`text-4xl font-bold mb-6 tracking-wide ${themeClass.titleColor}`}>
          No-Download Gaming Experience
        </h1>

        <p className={`text-lg leading-relaxed mb-6 ${themeClass.overlayText}`}>
          One of the biggest shifts in the gaming industry is the move toward <strong>no-download experiences</strong>. Thanks to HTML5 and modern web tech, high-quality games can now run directly in your browser—no installs, no delays.
        </p>

        <p className={`text-lg leading-relaxed mb-6 ${themeClass.overlayText}`}>
          At <strong>BrowserArena</strong>, our library is 100% no-download. That means no large files, no waiting for updates, and no compatibility headaches. Just click and play, whether you're on a Chromebook, tablet, or older laptop.
        </p>

        <p className={`text-lg leading-relaxed mb-6 ${themeClass.overlayText}`}>
          These games are also more secure. Without third-party installers, you reduce the risk of malware. Plus, you always play the latest version—automatically updated in the cloud.
        </p>

        <p className={`text-lg leading-relaxed mb-6 ${themeClass.overlayText}`}>
          We believe games should be fast, accessible, and inclusive. Whether you're squeezing in a quick match or exploring a new genre, our no-download games make it effortless to dive in.
        </p>

        <div className="mt-8 text-center">
          <p className={`text-base mb-4 ${themeClass.overlayText}`}>
            Learn more about{" "}
            <Link to="/about-browser-games" className={`${themeClass.hoverText} underline`}>
              browser games
            </Link>{" "}
            or jump straight into our{" "}
            <Link to="/html5-games" className={`${themeClass.hoverText} underline`}>
              HTML5 games
            </Link>{" "}
            collection now.
          </p>

          <Link
            to="/html5-games"
            className={`inline-block mt-4 px-6 py-2 text-base font-semibold rounded-full border ${themeClass.borderColor} ${themeClass.titleColor} hover:bg-cyan-400/10 hover:text-pink-500 transition`}
          >
            🎮 Browse No-Download Games
          </Link>
        </div>
      </div>
    </div>
    </div>
  );
}
